import React from 'react';
import { observer } from 'mobx-react';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import { BaasicHeader, Loader, BaasicTable, BaasicConfirmModal, TableFilter, BaasicDropdown } from 'core/components';
import _ from 'lodash';

const ReportListTemplate = ({
	t,
	reportListViewStore,
	reportListViewStore: {
		tableData,
		listStore,
		queryUtility,
		loading,
		isSuperAdmin,
		columnFilterSetup,
		showReports,
		onToggle,
		removeFiltersModal: { removeFiltersConfirm },
		organizationDropdownStore
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<BaasicHeader title="MAINMENU.REPORTS.TITLE">
				<div className="spc--right--sml">
					<ButtonGroupContainer {...{ t, showReports, onToggle }} />
				</div>
				{isSuperAdmin && (
					<BaasicDropdown
						dropdownStore={organizationDropdownStore}
						isClearable={true}
						className="w--200--px spc--right--tny"
						placeholder={t('PLACEHOLDER.ORGANIZATION')}
					/>
				)}
				<HeaderComponents {...{ reportListViewStore, t }} />
			</BaasicHeader>
			<div className="k-grid--expandable fullheight">
				<BaasicTable
					{...{
						tableData,
						queryUtility,
						viewStore: reportListViewStore,
					}}
					rowRender={CustomRowRender} // Use this for greying out the row if is template
					data={listStore.data.slice()}
					actions={reportListViewStore}
				/>
			</div>
			<TableFilter viewStore={reportListViewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersConfirm} />
		</React.Fragment>
	);
};

export default defaultTemplate(ReportListTemplate);

const HeaderComponents = observer(({ reportListViewStore, t }) => {
	const { openCreateNewTemplatePage, openCreateNewReportPage, loading } = reportListViewStore;
	return (
		<div>
			<button
				className="btn btn--med btn--primary btn--primary--negative u-mar spc--right--tny"
				disabled={loading}
				onClick={openCreateNewTemplatePage}
			>
				{t('REPORTS.ADDNEWTEMPLATE')}
			</button>
			<button
				className="btn btn--med btn--primary btn--primary--negative"
				disabled={loading}
				onClick={openCreateNewReportPage}
			>
				{t('REPORTS.ADDNEWREPORT')}
			</button>
		</div>
	);
});

const ButtonGroupContainer = props => {
	const { t, showReports, onToggle } = props;
	return (
		<ButtonGroup className="k-button-group--primary">
			<Button className="btn btn--sml" togglable={true} selected={showReports} onClick={() => onToggle(true)}>
				{t('REPORTS.SHOWREPORTS')}
			</Button>
			<Button className="btn btn--sml" togglable={true} selected={!showReports} onClick={() => onToggle(false)}>
				{t('REPORTS.SHOWTEMPLATES')}
			</Button>
		</ButtonGroup>
	);
};

function CustomRowRender(trElement, { dataItem }) {
	let className = trElement.props.className;
	if (dataItem.reportType.abrv == 'template') {
		className += ' is-template';
	}
	return <tr className={className}>{trElement.props.children}</tr>;
}
